// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sensors .add-button[data-v-499d39b7]{position:fixed;bottom:4%;right:44px;width:50px;height:50px;border-radius:50%;z-index:1031;font-size:24px;font-weight:700;padding-bottom:5px}.sensors .card .card-footer[data-v-499d39b7],.sensors .card .card-header[data-v-499d39b7]{display:-webkit-box;display:-ms-flexbox;display:flex}.sensors .card .card-footer p[data-v-499d39b7],.sensors .card .card-header p[data-v-499d39b7]{margin:auto 0 auto auto}", ""]);
// Exports
module.exports = exports;
